// extracted by mini-css-extract-plugin
export var aircallIframe = "_l4-3";
export var fabContainer = "_l4-5";
export var fabRinging = "_l4-6";
export var loadingOverlay = "_l4-4";
export var pulse = "_l4-7";
export var widgetContent = "_l4-2";
export var widgetPanel = "_l4-0";
export var widgetPanelExpanded = "_l4-1";